module.exports = __webpack_public_path__ + "static/media/empty-state-fuel-usage.d60128b7.svg";